import React, { useEffect } from 'react';
const ACUITY_SCRIPT_SRC = 'https://embed.acuityscheduling.com/js/embed.js';
const ACUITY_BOOKING_URL = 'https://app.acuityscheduling.com/schedule.php?owner=20909820&appointmentType=98927793';
const THANK_YOU_URL = 'https://weddings.twentymile-house.com/thank-you';
export function TourBooking() {
  // Load Acuity's embed script (handles auto-resizing of the calendar).
  useEffect(() => {
    document.querySelectorAll(`script[src="${ACUITY_SCRIPT_SRC}"]`).forEach(node => node.remove());
    const script = document.createElement('script');
    script.src = ACUITY_SCRIPT_SRC;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  // Acuity posts an "AcuityEvent" message after every booking (Custom Conversion Tracking).
  // Listen for it and send the couple to the thank-you page.
  useEffect(() => {
    function handleMessage(e: MessageEvent) {
      let d: unknown = e.data;
      try {
        if (typeof d === 'string') d = JSON.parse(d);
      } catch (x) {
        return;
      }
      if (d && typeof d === 'object' && (d as {
        event?: unknown;
      }).event === 'AcuityEvent') {
        window.location.href = THANK_YOU_URL;
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  return <section className="mx-auto mt-10 max-w-4xl px-4 md:px-6" aria-labelledby="tour-booking-heading" data-id="element-60" data-mp="3g44um9vj86mw">
      <h2 id="tour-booking-heading" className="mb-5 text-center font-display text-xl italic text-ink" data-id="element-61" data-mp="3b7o5pdgido8r">
        Book a virtual tour below! We’ll show you around and answer your questions.
      </h2>
      <iframe src={ACUITY_BOOKING_URL} title="Schedule your virtual tour" width="100%" height="800" frameBorder="0" allow="payment" data-id="element-62" data-mp="324wr54sc6ccw" />
    </section>;
}